import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=e54067d0"
import script from "./Properties.js?vue&type=script&lang=js&external"
export * from "./Properties.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports